
import { Vue, Component } from 'vue-property-decorator'
import { apiStorageList, apiStorageChange } from '@/api/setting'
@Component({
    components: {}
})
export default class StorageIndex extends Vue {
    /** S Data **/
    list = []
    oldEngine = 'local' // เครื่องยนต์เริ่มต้น
    /** E Data **/

    /** S Methods **/
    // ข้ามไปที่หน้าการตั้งค่าเครื่องยนต์
    onStorageEdit(item: any) {
        this.$router.push({
            path: '/setting/storage/storage',
            query: {
                engine: item.engine // เครื่องยนต์จัดเก็บข้อมูล
            }
        })
    }

    // รับรายการเครื่องมือจัดเก็บข้อมูล
    getStorageList() {
        apiStorageList()
            .then((res: any) => {
                this.list = res
                console.log(res)
                // this.$message.success("ลบสำเร็จ!");
            })
            .catch(() => {
                this.$message.error('ไม่สามารถรับข้อมูลได้，โปรดลองอีกครั้ง！')
            })
    }
    // สวิตช์เครื่องยนต์
    postStorageChange(item: any) {
        apiStorageChange({ engine: item.engine })
            .then((res: any) => {
                this.getStorageList()
                this.$message.success('อัปเดตสำเร็จ')
            })
            .catch(() => {
                this.$message.error('การอัปเดตล้มเหลว')
            })
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getStorageList()
    }
    /** E Life Cycle **/
}
